---
en:
  ppa_pricing:
    charts:
      buy_back_cost_title: Buy-back cost (EUR)
      buy_back_volume_title: Buy-back volume as % of annual production
      portfolio_reference_title: Portfolio and reference profile
      profile_risk: Profile risk [%]
      simulated_revenue_development: Simulated revenue development
    factors:
      cannibalism: Cannibalism
      cash_flow: Cash-flow
      liquidity: Liquidity
      price: Price
      profile: Profile
      volume: Volume
    hedging_strategy: Hedging strategy price and risks
    liquidity: Liquidity
    portfolio_attributes: Portfolio attributes
    pricing: Pricing
    pricing_and_risk: Product pricing and risks
    risk_factors: Risk Factors
    risk_factors_additional: Additional Risk Factors
    risk_factors_mitigated: Risk Factors Mitigated
